import { api } from '@/lib/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getPushPermission() {
  if (!pushSupported()) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

let swReg = null;
async function registerSW() {
  if (swReg) return swReg;
  swReg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;
  return swReg;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error('Push not supported on this device/browser');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permission denied');

  const { data } = await api.get('/push/vapid-public-key');
  if (!data.enabled || !data.public_key) throw new Error('Push not configured on server');

  const reg = await registerSW();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await api.post('/push/subscribe', { endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disablePush() {
  if (!pushSupported()) return;
  const reg = await registerSW();
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const json = sub.toJSON();
    try { await api.post('/push/unsubscribe', { endpoint: json.endpoint, keys: json.keys }); } catch (e) {}
    await sub.unsubscribe();
  }
}

export async function isPushActive() {
  if (!pushSupported() || Notification.permission !== 'granted') return false;
  try {
    const reg = await registerSW();
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch (e) { return false; }
}

export async function sendTestPush() {
  return api.post('/push/test');
}
